import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { RemindersActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createReminder = (data): any => action(types.CREATE_REMINDER_REQUESTED, data);

export const updateReminder = (data): any => action(types.UPDATE_REMINDER_REQUESTED, data);

export const deleteReminder = (reminderId): any => action(types.UPDATE_REMINDER_REQUESTED, reminderId);

export const getReminder = (reminderId): any => action(types.GET_REMINDER_REQUESTED, reminderId);

export const getAllReminders = (
  organisationId: string,
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_REMINDERS_REQUESTED, {
  organisationId,
  pagination,
  compile,
});

export const selectReminder = (reminderId): any => action(types.SELECT_REMINDER_REQUESTED, {
  currentReminderId: reminderId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createReminderPending: (payload): any => action(types.CREATE_REMINDER_PENDING, payload),
  createReminderSuccess: (response): any => action(types.CREATE_REMINDER_SUCCESS, {
    remindersById: response.entities.reminders,
    currentReminderId: response.result,
  }),
  createReminderFailed: (error): any => action(types.CREATE_REMINDER_FAIL, { backendErrors: error }),
  updateReminderPending: (payload): any => action(types.UPDATE_REMINDER_PENDING, payload),
  updateReminderSuccess: (response): any => action(types.UPDATE_REMINDER_SUCCESS, {
    remindersById: response.entities.reminders,
    currentReminderId: response.result,
  }),
  updateReminderFailed: (error): any => action(types.UPDATE_REMINDER_FAIL, { backendErrors: error }),
  deleteReminderPending: (): any => action(types.UPDATE_REMINDER_PENDING, {}),
  deleteReminderSuccess: (response, userId): any => {
    localStorage.set(userId, { currentReminderId: null });
    history.push('/reminders');

    return action(types.DELETE_REMINDER_SUCCESS, {
      currentReminderId: response,
    });
  },
  getReminderPending: (): any => action(types.GET_REMINDER_PENDING, {}),
  getReminderSuccess: (response): any => action(types.GET_REMINDER_SUCCESS, {
    remindersById: response.entities.reminders,
    currentReminderId: response.result,
  }),
  getReminderFailed: (error): any => action(types.GET_REMINDER_FAIL, { backendErrors: error }),
  deleteReminderFailed: (error): any => action(types.UPDATE_REMINDER_FAIL, { backendErrors: error }),
  getAllRemindersPending: (pagination): any => action(types.GET_ALL_REMINDERS_PENDING, { pagination }),
  getAllRemindersSuccess: (response, meta): any => action(types.GET_ALL_REMINDERS_SUCCESS, {
    remindersById: response.entities.reminders,
    reminderIds: response.result,
    meta,
  }),
  getAllRemindersFailed: (error): any => action(types.GET_ALL_REMINDERS_FAIL, { backendErrors: error }),
};

export default null;
